/**
 * Create an INDEPENDENT frogger span that carries the app base context.
 *
 * `useFrogger()` instances do NOT inherit the ambient `frogger` logger's context,
 * so this helper is the DRY way to get a fresh span (one logger = one span) that
 * still stamps tenant/env/version. Reach for it per navigation, per data request,
 * or per component/flow where you want the logs correlated under their own span
 * but still filterable by tenant.
 *
 * ```ts
 * const log = useAppLogger({ surface: 'job-editor' })
 * log.info('job editor opened', { jobKey })
 * // group the backend hop under log's own span (installs log's child as active,
 * // so $api's ambient frogger.child() nests under it with no manual getHeaders):
 * await log.span('job-editor', () => $api('/jobs'))
 * ```
 *
 * For casual, zero-ceremony logging that shares one app-scoped span, use the
 * ambient `frogger.*` instead — the root plugin has already stamped base context
 * onto it.
 */
export function useAppLogger(context?: Record<string, unknown>) {
	return useFrogger({ context: { ...useFroggerBaseContext(), ...(context ?? {}) } });
}
